<template>
  <v-container fluid class="fill-height primary" style="height: 100vh">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card>
          <v-form @submit.prevent="signin">
            <v-container>
              <v-row justify="center">
                <v-icon color="primary" size="128">mdi-account</v-icon>
              </v-row>
              <v-alert type="error" v-show="error.message">{{ error.status + ' ' + error.message }}</v-alert>
              <v-text-field
              v-model="username"
              label="아이디"
              outlined
              ></v-text-field>
              <v-text-field
              v-model="password"
              label="비밀번호"
              type="password"
              outlined></v-text-field>
              <v-btn block color="primary" x-large type="submit" :loading="loading" :disabled="Object.values(agreements).some(v => !v)">로그인</v-btn>
            </v-container>
            <v-divider></v-divider>
            <v-card-text>
              서비스를 이용하시려면 이용약관및 위치정보 제공에 동의하셔야합니다.
              <a href="https://loop-info.web.app/notice" target="__blank" class="d-flex align-center">공지사항 보기<v-icon small color="primary">mdi-open-in-new</v-icon></a>
              <a href="https://loop-info.web.app/policy" target="__blank" class="d-flex align-center">이용약관 보기<v-icon small color="primary">mdi-open-in-new</v-icon></a>
              <a href="https://loop-info.web.app/privacy" target="__blank" class="d-flex align-center">개인위치정보 처리방침 보기<v-icon small color="primary">mdi-open-in-new</v-icon></a>
              <a href="/service_location" target="__blank" class="d-flex align-center">위치정보 제공 동의서 보기<v-icon small color="primary">mdi-open-in-new</v-icon></a>
              <div class="d-flex justify-end">
                <v-checkbox label="이용약관에 동의" hide-details v-model="policyAgreement" color="primary"></v-checkbox>
              </div>
              <div class="d-flex justify-end">
                <v-checkbox label="개인위치정보 처리방침에 동의" hide-details v-model="policy2Agreement" color="primary"></v-checkbox>
              </div>
              <div class="d-flex justify-end">
                <v-checkbox label="위치정보 제공에 동의" hide-details v-model="serviceLocationAgreement" color="primary"></v-checkbox>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      agreements: {
        policy: localStorage.getItem('policy_agreement') === 'true',
        policy2: localStorage.getItem('policy2_agreement') === 'true',
        serviceLocation: localStorage.getItem('service_location_agreement') === 'true'
      },
      username: '',
      password: '',
      loading: false,
      error: {
        status: 500,
        message: ''
      }
    }
  },
  computed: {
    policyAgreement: {
      set (value) {
        localStorage.setItem('policy_agreement', value)
        this.agreements.policy = value
      },
      get () {
        return this.agreements.policy
      }
    },
    policy2Agreement: {
      set (value) {
        localStorage.setItem('policy2_agreement', value)
        this.agreements.policy2 = value
      },
      get () {
        return this.agreements.policy2
      }
    },
    serviceLocationAgreement: {
      set (value) {
        localStorage.setItem('service_location_agreement', value)
        this.agreements.serviceLocation = value
      },
      get () {
        return this.agreements.serviceLocation
      }
    }
  },
  methods: {
    async signin () {
      if (this.loading) return
      this.loading = true
      const body = {
        username: this.username,
        password: this.password
      }
      try {
        await this.$store.dispatch('signin', body)
        location.href = '/'
      } catch (err) {
        this.error.status = err.status
        this.error.message = err.message
      }
      this.loading = false
    }
  }
}
</script>
